import React from "react";

function AboutCard() {
  return (
    <p className="home-about-body">
      I have worked in the following professions:
      <ul>
        <li>
          <span className="purple">Software Developer</span>
        </li>
        <li>
          <span className="purple">Application Manager</span>
        </li>
        <li>
          <span className="purple">Scrum Master</span>
        </li>
        <li>
          <span className="purple">Data Analyst</span>
        </li>
        <li>
          <span className="purple">Logistics Coordinator</span>
        </li>
      </ul>
      And in the following sectors:
      <ul>
        <li>
          <span className="purple">Retail</span>
        </li>
        <li>
          <span className="purple">Manufacturing</span>
        </li>
        <li>
          <span className="purple">Logistics</span>
        </li>
      </ul>
      I have a good understanding of the following topics:
      <ul>
        <li>
          <span className="purple">Software Development</span>
        </li>
        <li>
          <span className="purple">
            Project Management (Agile, Traditional)
          </span>
        </li>
        <li>
          <span className="purple">ERP and PIM systems</span>
        </li>
        <li>
          <span className="purple">Business Processes</span>
        </li>
      </ul>
    </p>
  );
}

export default AboutCard;
